import type { StaticEntityType } from "@config";
import { Set } from "@library-containers/layers";
import "../styles/Array.scss";
import { ArrayView } from "./Array.view";
import { Wrapper } from "./Wrapper";

export const ArrayLibrary = ({ entity }: { entity: StaticEntityType }) => {
  const { children, settings, id } = entity;
  return (
    <ArrayView entity={entity}>
      {children.map((child, index) => (
        <Wrapper entity={entity} id={child.id} key={child.id}>
          <Set
            entity={{
              ...child,
              layers: {
                ...(entity.layers || {}),
                combo: { settings, index, id },
              },
            }}
          />
        </Wrapper>
      ))}
    </ArrayView>
  );
};
